export interface Category {
  name: string;
  url: string;
  slug: string;
}

export const categories: Category[] = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', slug: 'shoes' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html', slug: 'hoodies-sweaters' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html', slug: 't-shirts' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html', slug: 'jackets' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html', slug: 'pants-shorts' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html', slug: 'headwear' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html', slug: 'sets' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html', slug: 'underwear-underpants' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html', slug: 'jersey' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html', slug: 'accessories' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html', slug: 'bags' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Bags.html', slug: 'belts' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Bags.html', slug: 'perfumes' },
  { name: 'OtherStuff', url: 'https://kaspreadsheet.com/search-924/name/Bags.html', slug: 'other-stuff' },
];